import * as ActionTypes from '../actions'
import { combineReducers } from 'redux'
import { mapValues, keyBy, filter, each } from 'lodash'



const list = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			const ret = {}
			each(action.response.comboboxes, (combos, name) => {
				ret[name] = filter(combos, item => !item.deleted)
			})
			return ret
		case ActionTypes.LOGOUT:
			return null
		default:
			return state
	}
}

const byKey = (state = null, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_GLOBALS_SUCCESS:
			return mapValues(action.response.comboboxes, (items) => keyBy(items, 'key'))
		case ActionTypes.LOGOUT:
			return null
		default:
			return state
	}
}

const comboboxesReducer = combineReducers({
	list,
	byKey
})

export default comboboxesReducer


// WEBPACK FOOTER //
// ./src/reducers/comboboxes.js